import ChartDatasets from "./datasets/dataset_helper"
import ChartOptions from "./options/options"
export default {
    name: "GenreChartComponent",
    labels: ['F','M'],
    loading: false,
    style:"height: 150px",
    datasets: [{
        data: [0, 0],
        backgroundColor: [
            'rgba(240, 90, 161)',
            'rgba(54, 80, 235)',
        ],
        borderWidth: 2,
        hoverOffset: 2
    }],
    options: {
        responsive:true,
        legend:{
            display: true,
            labels: {
                fontColor: 'rgba(255, 255, 255)'
            }
        }
    }
}